// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wVQJ","name":"styles_name__9yBi4","phone":"styles_phone__ep1Q6"};